import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack, MenuItem } from "@mui/material";
const CampsForm = () => {

    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }

    return (
        <>

            <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                <Stack spacing={2}>
                    <h1>Camps Form</h1>

                    <TextField name="camp_id" label='Camp id' {...register("camp_id")} />

                    <TextField name="location_street" label='Location street' {...register("location_street")} />

                    <TextField name="camp_use" label='Usage type of the camp' {...register("camp_use")} />

                    <TextField name="operated_by" label='Operated by' {...register("operated_by")} />



                    <label>Date of start:</label>
                    <input type="date" id='date_started' {...register('date_started', { valueAsDate: true })} />

                    <label>Date of end:</label>
                    <input type="date" id='date_ended' {...register('date_ended', { valueAsDate: true })} />

                    <TextField type='number' name="number_people" label='number of people' {...register("number_people", { valueAsNumber: true })} />

                    <TextField type='number' name="number_prisoners" label='number of prisoners' {...register("number_prisoners", { valueAsNumber: true })} />

                    <label htmlFor="notes">Notes:</label>
                    <textarea name="notes" id="notes" {...register('notes')}></textarea>

                    <TextField  name="link_archive" label='Link of the archive' {...register("link_archive")} />

                    <label htmlFor="other_sources">Other Sources</label>
                        <textarea name="other_sources" id="other_sources" {...register('other_sources')}></textarea>


                    <Button type='submit' variant="outlined">Submit</Button>

                </Stack>

            </form>

        </>
    )
}

export default CampsForm